// Sample data for EcoControlSensors component
export const sensorSections = [
  {
    title: "Pharmacy",
    metrics: [
      { type: "Temperature", value: 2, unit: "℃", updated: "8:30 AM" },
      { type: "Humidity", value: 55, unit: "%", updated: "8:30 AM" },
    ],
  },
  {
    title: "Dispensary",
    metrics: [
      { type: "Temperature", value: 19, unit: "℃", updated: "8:30 AM" },
      { type: "Humidity", value: 55, unit: "%", updated: "8:30 AM" },
    ],
  },
  {
    title: "Pharmacy - Bin Number 1223",
    metrics: [
      { type: "Temperature", value: 24, unit: "℃", updated: "8:30 AM" },
      { type: "Humidity", value: 55, unit: "%", updated: "8:30 AM" },
    ],
  },
];

export const medicationTableData = [
  { drug: 'Amoxicillin 250mg', category: 'Antibiotics', temp: '20 - 25', unit: '', qty: 150, note: 'High demand item.' },
  { drug: 'Paracetamol 500mg', category: 'Painkillers', temp: '20 - 25', unit: '', qty: 45, note: 'Nearing reorder level.' },
  { drug: 'Omeprazole 20mg', category: 'GI Drugs', temp: '20 - 25', unit: '', qty: 15, note: 'Blood pressure medication.' },
];

export const medicationTableColumns = [
  { header: 'Drug Name', accessor: 'drug' },
  { header: 'Category', accessor: 'category' },
  { header: 'Temp (℃)', accessor: 'temp' },
  { header: 'Qty', accessor: 'qty' },
  { header: 'Note', accessor: 'note' },
];

export const sensorPerformanceData = {
  upTime: '99.9%',
  lastCalibrated: '18/06/2025',
  accuracy: '95%'
};

export const chartData = {
  humidity: '● Humidity',
  temperature: '● Temperature'
};
